module.exports = __webpack_public_path__ + "static/media/laadela.1578664a.jpg";